import { Box, InputAdornment } from '@mui/material';
import { getDefaultCountryCode } from 'intl/helpers';
import { MuiTelInput, MuiTelInputCountry } from 'mui-tel-input';
import { Color } from 'shared/utils/colors';
import { ReactElement } from 'react';
import { CopyTextIcon } from './cardActions/copyText';

const charWidth = 10;
// Add space for icon, padding etc.
const additionalSpace = 40;

export const PhoneNumber = ({
  phone,
  setOpenSnackbar,
}: {
  phone: string;
  setOpenSnackbar: (open: boolean) => void;
}): ReactElement | null => {
  if (!phone) {
    return null;
  }

  // Calculate width based on phone number length
  const calculatedWidth = phone.length * charWidth + additionalSpace;

  return (
    <Box
      sx={{
        position: 'relative',
        '&:hover': {
          '& .copy-icon': {
            opacity: 1,
          },
          '& .Mui-disabled': {
            WebkitTextFillColor: `${Color.primaryOrangeDark} !important`,
          },
        },
      }}
    >
      <MuiTelInput
        size='small'
        margin='none'
        sx={{
          display: 'inline-flex',
          // I was not able to position the input with the fit-content or auto
          // maybe it will be achievable in  newer MUI version (currently 5.15.21)
          // or MUI Tel Input version (currently 6.0.1)
          width: calculatedWidth,
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            paddingLeft: 0,
          },
          '& .MuiOutlinedInput-root': {
            paddingLeft: 0,
          },
          '& .Mui-disabled': {
            transition: 'color 0.2s',
          },
          '& .MuiInputBase-input': {
            py: 1,
          },
          '& .MuiTelInput-FlagImg': { maxWidth: '20px' },
          '& .MuiTelInput-IconButton': { maxWidth: '20px' },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <CopyTextIcon
                value={phone}
                setOpenSnackbar={setOpenSnackbar}
              />
            </InputAdornment>
          ),
        }}
        inputProps={{
          style: {
            width: 'auto',
            fontSize: 14,
          },
        }}
        disabled
        value={phone}
        defaultCountry={getDefaultCountryCode() as MuiTelInputCountry}
      />
    </Box>
  );
};
